import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { fetch } from "@/src/lib/fetch";
import { ComboboxMulti } from "../../../components/ui/combobox-multi";

type Operator = {
  name: string;
};

export const Operator = () => {
  return (
    <div className="w-full">
      <h3 className="text-lg font-semibold col-span-full mb-10">Operator</h3>
      <FormField<FiltersFormT, "operator">
        name="operator"
        render={({ field }) => {
          return (
            <FormItem>
              <FormControl>
                <ComboboxMulti
                  className="flex w-full"
                  loadOptions={(query) =>
                    fetch<{ data: Operator[] }>(`/api/operators/operators?pageSize=5&filter=${query}`).then((r) =>
                      r.data?.map((o) => ({
                        label: o.name,
                        value: o.name,
                      })),
                    )
                  }
                  placeholder="Search for operator..."
                  value={field.value ?? []}
                  onChange={(v) => {
                    field.onChange(v);
                  }}
                />
              </FormControl>
            </FormItem>
          );
        }}
      />
    </div>
  );
};
